import * as Parts from './Toolbar.parts'

export const ToolbarRoot = Parts.Root
export const ToolbarSeparator = Parts.Separator
export const ToolbarButton = Parts.Button
